import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

const slice = createSlice({
  name: 'auth',
  initialState: { username: null, token: null, name: null } as {
    username: null | string;
    token: null | string;
    name: null | string;
  },
  reducers: {
    setCredentials: (
      state,
      {
        payload: { username, token, name }
      }: PayloadAction<{ username: string; token: string; name: string }>
    ) => {
      state.username = username;
      state.token = token;
      state.name = name;
    },
    clearCredentials: (state) => {
      state.username = null;
      state.token = null;
      state.name = null;
    }
  },
  extraReducers: (builder) => {}
});

export const { setCredentials, clearCredentials } = slice.actions;
export default slice.reducer;
export const selectCurrentUser = (state: RootState) => state.auth.username;
export const selectCurrentName = (state: RootState) => state.auth.name;